var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebookBlue = function SvgFacebookBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25.759,
    cy: 25.759,
    r: 25.759,
    fill: "#EFF6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636363",
    fillRule: "nonzero",
    d: "m32.573 12.132-4.072-.166a5.982 5.982 0 0 0-5.982 5.9v3.822h-3.74a.249.249 0 0 0-.249.249v4.82a.416.416 0 0 0 .25.249h3.739v12.048c0 .167.166.25.332.25h4.903a.25.25 0 0 0 .249-.25V27.006h3.74c.165 0 .248-.083.331-.25l.582-4.736a.334.334 0 0 0-.083-.25h-4.57v-2.409a2.91 2.91 0 0 1 .498-1.828c.295-.33.721-.513 1.164-.499h2.825c.166 0 .332-.083.332-.249v-4.32a.25.25 0 0 0-.249-.334z"
  }))));
};
export default SvgFacebookBlue;